// Centralized API configuration
// All API URL logic should use these exports instead of redeclaring

const rawApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Strip trailing /api to get the base URL
export const API_BASE = rawApiUrl.replace(/\/api\/?$/, '');

// Full API URL with /api path
export const API_URL = `${API_BASE}/api`;
